// extracted by mini-css-extract-plugin
export default {"control":"NavbarLinksGroup_control__Z7lgq","link":"NavbarLinksGroup_link__Z3GBM","chevron":"NavbarLinksGroup_chevron__SrckR"};